import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authContext } from '../contexts/AuthContext';

interface AuthenticatedProps {
  children: React.ReactElement;
}

/**
 * Signed-in only. A signed-out visitor is sent to the login screen, carrying where they
 * were headed so Public can send them on after they sign in. That is what makes the QR
 * code on the venue screen land a new patron on the jukebox rather than on home.
 */
const Authenticated = ({ children }: AuthenticatedProps) => {
  const context = useContext(authContext);
  const location = useLocation();
  return context.auth.id ? children : <Navigate to="/" replace state={{ from: location }} />;
};

export default Authenticated;
